import { useEffect, useState } from 'react';
import { base44 } from '@/api/base44Client';

/**
 * Loads the single EventsPage config record. `config` is null while loading or
 * when no record exists yet.
 */
export function useEventsPage() {
  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    base44.entities.EventsPage.list()
      .then((records) => { if (active) setConfig(records[0] || null); })
      .catch(() => {})
      .finally(() => { if (active) setIsLoading(false); });
    return () => { active = false; };
  }, []);

  return { config, isLoading, isPublished: !!config?.is_published };
}